import { inject, NewInstance } from 'aurelia-framework';
import { MaterialService } from 'pages/system-fields/materials/service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { DialogController } from 'aurelia-dialog';
import { ValidationRules, ValidationController, validateTrigger } from 'aurelia-validation';
import { BootstrapFormRenderer } from 'resources/validation-renderer';
import toastr from 'toastr';

@inject(DialogController, NewInstance.of(ValidationController), MaterialService, EventAggregator)
export class MaterialEditor {
    constructor(controller, validationController, materialService, ea) {
        this.controller = controller;
        this.materialService = materialService;
        this.ea = ea;
        this.material = {};

        this.validationController = validationController;
        this.validationController.validateTrigger = validateTrigger.manual;
        this.validationController.addRenderer(new BootstrapFormRenderer());
        this.rules = ValidationRules
            .ensure('name').required()
            .rules;
    }

    async activate(model) {
        if (model?.id != null) {
            this.material = await this.materialService.getById(model.id);
        }
    }

    attached() {
        this.uxBody.querySelector('input').focus();        
    }

    async save() {
        if (this.isRequesting) return;
        this.isRequesting = true;
        const validationResult = await this.validationController.validate();
        if (validationResult.valid) {
            try {
                if (this.material.id) {
                    await this.materialService.update(this.material);
                    toastr.success('Material was updated!');
                } else {
                    await this.materialService.create(this.material);
                    toastr.success('New material was created!');
                }
                this.ea.publish('materials:updated', this.material);
                this.controller.ok(this.material);
            } catch {
                this.isRequesting = false;
            }
        }
        this.isRequesting = false;
    }
}